import { render, staticRenderFns } from "./PMChartVersionsTable.vue?vue&type=template&id=63c88b9c&"
import script from "./PMChartVersionsTable.vue?vue&type=script&lang=ts&"
export * from "./PMChartVersionsTable.vue?vue&type=script&lang=ts&"
import style0 from "./PMChartVersionsTable.vue?vue&type=style&index=0&id=63c88b9c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports